import { required } from "@corporate-tailwind/corp-form";
import { DueDiligenceDto, DueDiligenceSchema } from "./due-diligence.model";
import { BusinessExceptionMessage } from "src/app/shared/model/business-exception.model";

export class OrderDueDiligenceDto {
    dueDiligenceDto: DueDiligenceDto | null = null;
    businessExceptionMessages: BusinessExceptionMessage[] | null = null;
}

export class OrderDueDiligenceSchema extends OrderDueDiligenceDto {
    static schema = {
        dueDiligenceDto: { type: DueDiligenceSchema, builderOption: required }

    }
}
